export type JoinPhase = 'broadcast' | 'nattering';

/**
 * The phase a client first landed in this session, from whether it processed broadcastStarted_WS
 * before its first round. A broadcast viewer always receives that WS (it carries the broadcast access
 * token), so seeing it means they joined into a broadcast; never seeing it means they joined straight
 * into an in-progress nattering round.
 *
 * Note: broadcasts carry no global sequence/timestamp, so a join during a later broadcast (e.g. after
 * round 1) is indistinguishable from the opening broadcast — both are 'broadcast'. Nattering joins are
 * pinned to a round via roundStartTime, so the round ordinal is derivable at query time.
 */
export const classifyJoinPhase = (sawBroadcast: boolean): JoinPhase => (sawBroadcast ? 'broadcast' : 'nattering');
